import { Component, Input, OnInit } from '@angular/core';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';

@Component({
  selector: 'app-implementation',
  templateUrl: './implementation.component.html',
  styleUrls: ['./implementation.component.scss'],
})
export class ImplementationComponent implements OnInit {

  @Input()info

  constructor(public languageService : LanguagesService) { }

  ngOnInit() {
  //  document.getElementById('detailKpi').innerHTML = this.info.kpi_config.description
   }

  get getTextsIUPageKpi() {
    return this.languageService.textsIU.page_kpi;
  }

}
